import { render } from "./MessagesContainer.vue?vue&type=template&id=3f7c1ae0"
import script from "./MessagesContainer.vue?vue&type=script&lang=js"
export * from "./MessagesContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__